


import qs from "qs";
import {Toast} from "vant";

export default {
  name: 'MoreSelect',
  props: {
    userName: {
      type: String,
      required: true
    },
    registerUser:{
      type: String,
      required: true
    }
  },


  methods: {
    handleSetMore(type) {
      switch (type){
        case 1:
          this.goToResetPasswordPage()
          break
        case 2:
          this.$router.push('/Register')
          break
        /* case 3:
           this.$router.push({path: '/Help',query:{lang:'zh'}})
          break*/
      }

    },
    goToResetPasswordPage(){
      if(this.userName){
        this.$ajax.post("/etv/getSimpleInfo.json", qs.stringify({
          account: this.userName
        })).then(res => {
          if (res.data.code === 0) {
            const { email, phone} = res.data.data
            // 定义跳转逻辑，例如使用Vue Router或修改window.location
            this.$router.push({path: '/resetPwd', query:{username:this.userName,email,phone}})
          }else{
            Toast(res.data.msg,'fail')
          }
        })

      }else{
        Toast(this.$t('append_field.enter_account'),'fail')
      }
    },

  }
}
